import React, { forwardRef, Ref, SVGProps } from 'react'

const _IconTravelStaytionRectangle = (props: SVGProps<SVGSVGElement>, ref?: Ref<SVGSVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" {...props} ref={ref}>
    <rect x="0.199951" width="24" height="24" rx="6" fill="black" />
    <path
      d="M17.4558 16.5306L14.251 9.76468C14.1692 9.59204 13.9984 9.47902 13.8075 9.47178C12.7434 9.43144 11.7225 9.40144 10.7923 9.32455C9.37568 9.20747 9.45855 8.19675 9.59384 7.78177C9.83341 7.047 11.3891 6.93301 11.4773 7.76516C11.5447 8.401 12.0811 8.58709 12.7281 8.30472C13.2458 8.07882 13.3351 7.68973 13.1169 7.18972L12.4495 5.6603C12.336 5.4004 12.0334 5.28165 11.7735 5.39507L7.42633 7.29212C7.16418 7.40651 7.04605 7.71307 7.16364 7.9738L12.1334 18.9927C12.2507 19.253 12.5579 19.3675 12.817 19.2476L17.2073 17.2164C17.4663 17.0966 17.5779 16.7885 17.4558 16.5306Z"
      fill="white"
    />
  </svg>
)

export const IconTravelStaytionRectangle = forwardRef(_IconTravelStaytionRectangle)
